// 외부 연동 키 설정 URL (2026-08-30 KST 추가)
export const tossSettingsPath = "/toss-settings";
export const deliveryTrackerSettingsPath = "/delivery-tracker-settings";
